module.exports = __webpack_public_path__ + "img/code1.acd013fe.png";